export type FieldMeta = {
    key: string;
    label: string;
    value: unknown;
    required?: boolean;
    touched?: boolean;
    id?: string;
    name?: string;
};

export type ValidationResult = {
    valid: boolean;
    errorsByField: Record<string, string>;
    firstInvalidField?: string;
};

export function normalizeErrorMap(errorsByField: Record<string, string>) {
    return Object.entries(errorsByField).reduce<Record<string, string>>((acc, [key, value]) => {
        const msg = String(value || '').trim();
        if (!msg) return acc;
        acc[key] = msg;
        return acc;
    }, {});
}

export function validateRequiredFields(fields: FieldMeta[]): ValidationResult {
    const errorsByField: Record<string, string> = {};
    for (const field of fields) {
        if (!field.required) continue;
        const value = field.value;
        const isEmpty =
            value === null ||
            value === undefined ||
            (typeof value === 'string' && value.trim() === '') ||
            (typeof value === 'number' && Number.isNaN(value));
        if (isEmpty) {
            errorsByField[field.key] = `${field.label} is required`;
        }
    }
    const normalized = normalizeErrorMap(errorsByField);
    const firstInvalidField = Object.keys(normalized)[0];
    return {
        valid: Object.keys(normalized).length === 0,
        errorsByField: normalized,
        firstInvalidField,
    };
}

export function mergeValidationErrors(
    ...errorMaps: Array<Record<string, string> | undefined>
): ValidationResult {
    const merged = normalizeErrorMap(
        errorMaps.reduce<Record<string, string>>((acc, map) => ({ ...acc, ...(map || {}) }), {})
    );
    const firstInvalidField = Object.keys(merged)[0];
    return {
        valid: Object.keys(merged).length === 0,
        errorsByField: merged,
        firstInvalidField,
    };
}

export function focusFirstInvalidField(fieldKey?: string) {
    if (!fieldKey) return;
    const escaped = fieldKey.replace(/"/g, '\\"');
    const selector = `[name="${escaped}"], #${escaped}`;
    const element = document.querySelector<HTMLElement>(selector);
    if (!element) return;
    element.focus();
    element.scrollIntoView({ block: 'center', behavior: 'smooth' });
}

